export default "__VITE_ASSET__$C_VwPRh__"